exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-import .import-header-name[data-v-6d123096]{flex-shrink:0}", ""]);

// exports
